import React from 'react';
import { useTags } from '../../../hooks/useTags';
import { EnrichedTagsLayout, OnTagsEvent, ShowMoreTagsItemProps, Tag, TagItemProps } from '../../../types';
import { TagsContext } from './TagsContext';

interface TagsContextProviderProps {
    tags: Tag[];
    tagsLayout: EnrichedTagsLayout;
    numOfLines: number;
    parentWidth: number;
    TagItem: React.FC<TagItemProps>;
    ShowMoreTagsItem: React.FC<ShowMoreTagsItemProps>;
    onShowMoreTags: OnTagsEvent;
    tagsToShowLimit?: number;
    linesOffsets?: number[];
    onViewTags?: OnTagsEvent;
}

export const TagsContextProvider: React.FC<TagsContextProviderProps> = ({
    tags,
    tagsLayout,
    numOfLines,
    parentWidth,
    TagItem,
    ShowMoreTagsItem,
    linesOffsets,
    tagsToShowLimit,
    onViewTags,
    onShowMoreTags,
    children,
}) => {
    const { isLoading, shownTags, showAllTags } = useTags({
        tags,
        tagsLayout,
        numOfLines,
        parentWidth,
        linesOffsets,
        tagsToShowLimit,
    });

    const hiddenTagsCount = tags.length - shownTags.length;

    return (
        <TagsContext.Provider
            value={{
                tags,
                tagsLayout,
                numOfLines,
                TagItem,
                ShowMoreTagsItem,
                onViewTags,
                onShowMoreTags,
                isLoading,
                shownTags,
                showAllTags,
                hiddenTagsCount,
            }}
        >
            {children}
        </TagsContext.Provider>
    );
};
